import React, { useState } from "react";
import {
  FirstAds,
  SecondAds,
  MobileUnderCalAds,
} from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SharedHelmet from "../Helmet";

const TITLE = "Kalkulator Ukuran Bra - Temukan Ukuran Bra Sempurna Anda";
const DESCRIPTION =
  "Temukan ukuran bra ideal yang pas dengan bentuk tubuh Anda secara akurat menggunakan kalkulator ukuran bra canggih kami. Masukkan ukuran lingkar dada dan lingkar bawah dada Anda dengan teliti untuk mendapatkan ukuran bra yang sesuai. Baik Anda mencari kenyamanan atau gaya, alat ini memberikan cara terbaik untuk memilih ukuran yang tepat, memberi Anda kepercayaan diri dan kenyamanan yang layak Anda dapatkan. Ideal bagi wanita yang ingin mendapatkan ukuran bra sempurna dengan mudah dan presisi.";
const KEYWORDS =
  "kalkulator ukuran bra, ukuran bra, ukur bra, cara ukur bra, mengetahui ukuran bra, ukuran pakaian dalam, ukuran dada, lingkar dada, alat ukur bra, ukuran cup, ukuran band, ukuran tubuh, bra nyaman, penyangga dada, wanita modern.";
const OG_URL = "https://do-calculate.com/calculator/id/bra_size_calculator/";

const BraSizeCalculator = () => {
  const [bust, setBust] = useState("");
  const [band, setBand] = useState("");
  const [size, setSize] = useState(null);
  const [conversionSize, setConversionSize] = useState({
    size: "",
    location: "US/CA",
    cup: "A",
  });
  const [error, setError] = useState(null);

  const handleBustChange = (event) => {
    setBust(event.target.value);
  };

  const handleBandChange = (event) => {
    setBand(event.target.value);
  };

  const handleConversionChange = (event) => {
    const { name, value } = event.target;
    setConversionSize((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const calculateBraSize = () => {
    const bustNum = parseFloat(bust);
    const bandNum = parseFloat(band);
    if (isNaN(bustNum) || isNaN(bandNum) || bustNum <= 0 || bandNum <= 0) {
      setError("Silakan masukkan nilai yang valid");
      setSize(null);
      return;
    }
    const bandSize = bandNum + 4;
    const cupSize = bustNum - bandSize;
    let cup = "";
    if (cupSize < 1) {
      cup = "AA";
    } else if (cupSize < 2) {
      cup = "A";
    } else if (cupSize < 3) {
      cup = "B";
    } else if (cupSize < 4) {
      cup = "C";
    } else if (cupSize < 5) {
      cup = "D";
    } else {
      cup = "E";
    }
    setSize({
      band: bandSize,
      cup: cup,
    });
    setError(null);
  };

  const convertBraSize = () => {
    const { size, location, cup } = conversionSize;
    if (!size || !cup) {
      setError("Masukkan semua detail untuk konversi");
      return;
    }
    let convertedSize = "";
    const band = parseInt(size.replace(/\D/g, ""), 10);
    switch (location) {
      case "US/CA":
        convertedSize = `${band} ${cup}`;
        break;
      case "UK":
        convertedSize = `${band + 2} ${cup}`;
        break;
      case "EU(EN 13402)":
        convertedSize = `${band + 5} ${cup}`;
        break;
      case "Australia/New Zealand":
        convertedSize = `${band + 4} ${cup}`;
        break;
      case "US/CA (Underbust +4)":
        convertedSize = `${band + 4} ${cup}`;
        break;
      case "UK (Underbust +4)":
        convertedSize = `${band + 6} ${cup}`;
        break;
      case "UK Dress Code":
        convertedSize = `${band - 1} ${cup}`;
        break;
      default:
        convertedSize = `${band} ${cup}`;
    }
    setError(null);
    setConversionSize((prevState) => ({
      ...prevState,
      converted: convertedSize,
    }));
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px", lineHeight: "50px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="col-sm-12">
                <div className="p-3">
                  <p>
                    Temukan cara menentukan ukuran bra yang sempurna dengan mudah dan akurat 
                    menggunakan alat kalkulator ukuran bra canggih kami. Alat ini membantu 
                    Anda menghitung ukuran optimal berdasarkan ukuran lingkar dada dan lingkar 
                    bawah dada Anda. Cukup masukkan ukuran Anda dengan teliti, dan Anda akan 
                    mendapatkan ukuran yang sesuai untuk kenyamanan dan dukungan maksimal.
                  </p>
                  <p>
                    Apakah Anda mencari ukuran bra yang tepat untuk pakaian sehari-hari atau 
                    pakaian olahraga, alat ini menyediakan cara yang sederhana dan andal untuk 
                    mengetahui ukuran Anda. Alat ini juga memberikan tips tentang cara mengambil 
                    ukuran dengan benar untuk memastikan hasil yang paling akurat. Dirancang khusus 
                    untuk wanita yang ingin meningkatkan kepercayaan diri dan kenyamanan mereka 
                    melalui pemilihan ukuran yang tepat.
                  </p>
                  <p>
                    Dapatkan ukuran bra terbaik yang sesuai untuk Anda dengan menggunakan alat ini, 
                    dan nikmati kenyamanan serta gaya yang pantas Anda dapatkan. Melalui perhitungan 
                    yang tepat dan mudah, Anda dapat memastikan bahwa bra yang Anda pilih akan 
                    pas dengan sempurna dan memberikan dukungan ideal.
                  </p>
                </div>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>Kalkulator Ukuran Dada</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group d-flex align-items-center mb-3">
                    <b style={{ minWidth: "120px" }}>
                      <label className="form-label me-2">Lingkar Dada:</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Contoh: 38"
                      value={bust}
                      onChange={handleBustChange}
                      className="form-control"
                      style={{ width: "60%" }}
                    />
                    <span className="input-group-text">cm</span>
                  </div>
                  <div className="form-group d-flex align-items-center mb-3">
                    <b style={{ minWidth: "120px" }}>
                      <label className="form-label me-2">Lingkar Band:</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Contoh: 34"
                      value={band}
                      onChange={handleBandChange}
                      className="form-control"
                      style={{ width: "60%" }}
                    />
                    <span className="input-group-text">cm</span>
                  </div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateBraSize}
                  >
                    Hitung
                  </button>
                  <br />
                  <div className="mt-3">
                    {error !== null ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Kesalahan: {error}
                      </p>
                    ) : (
                      size && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <h4>
                            <u>Hasil:</u>
                          </h4>
                          <p>Ukuran Band: {size.band}</p>
                          <p>Ukuran Cup: {size.cup}</p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    Kalkulator Konversi Ukuran Bra
                  </h2>
                </div>
                <hr />
                <div>
                  <div className="form-group d-flex align-items-center mb-3">
                    <b style={{ minWidth: "150px" }}>
                      <label className="form-label me-2">Masukkan Ukuran Bra:</label>
                    </b>
                    <input
                      type="text"
                      id="conversionSize"
                      name="size"
                      value={conversionSize.size}
                      onChange={handleConversionChange}
                      className="form-control"
                      style={{ width: "60%" }}
                      placeholder="34B"
                    />
                  </div>
                  <div className="form-group d-flex align-items-center mb-3">
                    <b style={{ minWidth: "150px" }}>
                      <label className="form-label me-2">Sistem/Lokasi:</label>
                    </b>
                    <select
                      id="location"
                      name="location"
                      value={conversionSize.location}
                      onChange={handleConversionChange}
                      className="form-control"
                      style={{ width: "60%" }}
                    >
                      <option value="US/CA">US/CA</option>
                      <option value="UK">UK</option>
                      <option value="EU(EN 13402)">EU (EN 13402)</option>
                      <option value="Australia/New Zealand">Australia/New Zealand</option>
                      <option value="US/CA (Underbust +4)">US/CA (Underbust +4)</option>
                      <option value="UK (Underbust +4)">UK (Underbust +4)</option>
                      <option value="UK Dress Code">UK Dress Code</option>
                    </select>
                  </div>
                  <div className="form-group d-flex align-items-center mb-3">
                    <b style={{ minWidth: "150px" }}>
                      <label className="form-label me-2">Ukuran Cup:</label>
                    </b>
                    <select
                      id="cup"
                      name="cup"
                      value={conversionSize.cup}
                      onChange={handleConversionChange}
                      className="form-control"
                      style={{ width: "60%" }}
                    >
                      <option value="AA">AA</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                      <option value="DD/E">DD/E</option>
                      <option value="DDD/F">DDD/F</option>
                      <option value="DDDD/G">DDDD/G</option>
                      <option value="H">H</option>
                    </select>
                  </div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={convertBraSize}
                  >
                    Konversi
                  </button>
                  <br />
                  <div className="mt-3">
                    {error !== null ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Kesalahan: {error}
                      </p>
                    ) : (
                      conversionSize.converted && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <h4>
                            <u>Hasil:</u>
                          </h4>
                          <p>{conversionSize.converted}</p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>Apa itu Ukuran Bra?</h3>
            </div>
            <div className="info-section-body">
              <p>
                Ukuran bra adalah ukuran yang terdiri dari angka dan huruf. Angka 
                mewakili lingkar dada Anda tepat di bawah payudara (band size), 
                dan huruf mewakili volume cup bra. Ukuran yang benar ditentukan 
                melalui pengukuran lingkar dada dan ukuran cup.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Mengapa Penting Memilih Ukuran Bra yang Benar?
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                Memilih ukuran bra yang tepat sangat penting untuk kesehatan dan 
                kenyamanan. Bra yang tidak pas dapat menyebabkan nyeri punggung 
                dan leher, mempengaruhi sirkulasi darah, dan menyebabkan iritasi 
                kulit. Selain itu, bra yang sesuai meningkatkan rasa percaya diri 
                dan memberikan penampilan yang lebih baik.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Bagaimana Cara Mengukur Tubuh Saya untuk Mendapatkan Ukuran yang Tepat?
              </h3>
            </div>
            <div className="info-section-body">
              <p>Untuk mengukur tubuh Anda secara akurat, ikuti langkah-langkah berikut:</p>
              <ol>
                <li>Gunakan pita pengukur yang fleksibel.</li>
                <li>Ukur lingkar bawah dada Anda (tepat di bawah payudara).</li>
                <li>Ukur bagian terluas dari dada Anda.</li>
                <li>Hitung selisih antara kedua ukuran tersebut untuk mendapatkan ukuran cup.</li>
              </ol>
              <p>
                Untuk hasil yang lebih akurat, Anda dapat merujuk ke panduan ukuran 
                yang disertakan dengan kalkulator ini atau mencari video tutorial.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Tips Memilih Bra yang Sempurna
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                Selain memilih ukuran yang tepat, berikut adalah beberapa tips untuk 
                memilih bra yang sesuai:
              </p>
              <ul>
                <li>Cobalah bra sebelum membelinya.</li>
                <li>Pilih bra yang terbuat dari bahan alami (seperti katun).</li>
                <li>Pastikan tali bra nyaman dan tidak menyebabkan tekanan.</li>
                <li>Perhatikan desain cup dan pastikan memberikan dukungan yang cukup.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BraSizeCalculator;